import { updateUserPasswordSchema } from '../shared/validations/userValidations';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { useAuth } from '../utils/AuthContext.js';

const PasswordForm = ({ onFinish, submitLabel }) => {
  const { updateUserPassword } = useAuth();

  const handleSubmit = async ({ currentPassword, newPassword }) =>
    await updateUserPassword(currentPassword, newPassword);

  return (
    <ValidatedForm key="userPassword" schema={updateUserPasswordSchema} handleSubmit={handleSubmit} onFinish={onFinish}>
      <FormInput name="currentPassword" type="password" />
      <FormInput name="newPassword" type="password" />
      <FormInput name="newPasswordRepeated" type="password" />
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  );
};

export default PasswordForm;
